import { cardRootTV } from './card.styles.esm.js';
import { cardVariants as cardVariants$1 } from './card.variants.esm.js';
import cardCommon from './common/index.esm.js';

var cardColors = Object.keys(cardRootTV.variants.color);
var cardRadius = Object.keys(cardRootTV.variants.radius);
var cardShadows = Object.keys(cardRootTV.variants.shadow);
var cardPaddings = Object.keys(cardCommon.padding);
var cardVariants = Object.keys(cardVariants$1);
var cardFontSizes = ['p-10', 'p-12', 'p-14', 'p-16', 'p-18', 'p-20'];

export { cardColors, cardFontSizes, cardPaddings, cardRadius, cardShadows, cardVariants };
//# sourceMappingURL=types.esm.js.map
